// services/helper.js

import moment from "moment";

export default {
  scrollToTop(offset=0) {
    window.scrollTo({
      top: offset,
      behavior: 'smooth',
    });
  },
  maskEmail(email) {
    if (!email) return '';
    const [name, domain]=email.split('@');
    if (!name||!domain) return email;
    const masked=name.length>2? `${name[0]}***${name[name.length-1]}`:name[0]+'*';
    return `${masked}`;
  },
  maskUsername(username) {
    if (!username) return '';
    return `${username[0]}***${username[username.length-1]}`;
  },
  roundToHundreds(val) {
    return Math.round(val/100)*100;
  },
  productSelled(product) {
    if (undefined===product) return false;

    var bidsWon=product.bids.filter((b) => b.status===1);

    if (bidsWon.length>0) {
      let diffDays=Math.abs(
        moment(bidsWon[0].updated_at, "YYYY-MM-DD HH:mm:ss").diff(
          moment(),
          "days"
        )
      );

      if (diffDays>15&&product.orders.length===0) return false;

      return true;
    }

    var offerWon=product.offers.filter((o) => o.status===1);

    if (offerWon.length>0) {
      let diffDays=Math.abs(
        moment(offerWon[0].updated_at, "YYYY-MM-DD HH:mm:ss").diff(
          moment(),
          "days"
        )
      );

      if (diffDays>15&&product.orders.length===0) return false;

      return true;
    }

    return false;
  },

  formatPrice(price) {
    if (!price) return '0';
    return new Intl.NumberFormat('fr-DZ').format(price)+' DA';
  },

  /**
   * Format a date string / timestamp into a localized human readable date.
   * - Returns '-' when date is falsy.
   * - If the date can't be parsed, returns the original input as string.
   *
   * @param {string|number|Date} date
   * @param {string} locale
   * @param {Object} options Intl.DateTimeFormat options
   * @returns {string}
   */
  formatDate(date, locale='fr-DZ', options={ year: 'numeric', month: 'long', day: 'numeric' }) {
    if (!date) return '-';
    const d=new Date(date);
    if (Number.isNaN(d.getTime())) return String(date);
    return d.toLocaleDateString(locale, options);
  },

  /**
   * Format a date-time string / timestamp into a localized human readable format with hours, minutes, and seconds.
   * - Returns '-' when dateTime is falsy.
   * - If the date can't be parsed, returns the original input as string.
   *
   * @param {string|number|Date} dateTime
   * @param {string} locale
   * @param {Object} options Intl.DateTimeFormat options
   * @returns {string}
   */
  formatDateTime(dateTime, locale='fr-DZ', options={
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false
  }) {
    if (!dateTime) return '-';
    const d=new Date(dateTime);
    if (Number.isNaN(d.getTime())) return String(dateTime);
    return d.toLocaleString(locale, options);
  },
  truncate(text, length) {
    if (!text) return '';
    if (text.length<=length) return text;
    return text.substring(0, length)+'...';
  },
  boostClass(boost) {
    const type=boost.type;
    return {
      'bg-primary': type==='top_visibility',
      'bg-danger': type==='boost_ad',
      'bg-warning': type==='urgent_ad',
    };
  },
  getTranslatedLabel(item) {
    if (item.labelParams) {
      const params={};
      Object.keys(item.labelParams).forEach(key => {
        params[key]=this.$t(item.labelParams[key]);
      });
      return this.$t(item.label, params);
    }
    return this.$t(item.label);
  },
  getComputedStatus(purchase) {
    if (!purchase) return 'pending';

    if (purchase.status==='pending') return 'pending';
    if (purchase.status==='cancelled') return 'cancelled';

    if (purchase.status==='active') {

      // 🔴 expired
      if (purchase.product.is_active===true&&purchase.time_left<0) {
        return 'expired';
      }

      // 🟡 in progress
      if (purchase.product.is_active===true&&purchase.time_left>0) {
        return 'inProgress';
      }

      // 🟢 completed
      if (purchase.product.is_active===false&&purchase.time_left<0) {
        return 'completed';
      }

      // 🔵 active (fallback)
      return 'active';
    }

    return purchase;
  },
  getStatusBadgeClass(status) {

    const stat=this.getComputedStatus(status);

    const classes={
      boosted: 'badge badge-pill badge-primary',
      active: 'badge badge-pill badge-primary',
      validated: 'badge badge-pill badge-primary',
      inProgress: 'badge badge-pill badge-primary',
      top_visibility: 'badge badge-pill status-primary',
      pending: 'badge badge-pill badge-warning',
      reviewed: 'badge badge-pill badge-success',
      completed: 'badge badge-pill badge-success',
      sold: 'badge badge-pill badge-success',
      rejected: 'badge badge-pill badge-danger',
      deleted: 'badge badge-pill badge-danger',
      cancelled: 'badge badge-pill badge-danger',
      boost_ad: 'badge badge-pill status-losing',
      urgent_ad: 'badge badge-pill status-outbid',
      expired: 'badge badge-pill badge-secondary'
    };
    return classes[stat]||'badge badge-pill badge-secondary';
  },
  priorityBoost() {
    if (!this.product.active_boost||!this.product.active_boost.length) {
      return null;
    }

    // 1️⃣ top_visibility has priority
    const topVisibility=this.product.active_boost.find(
      b => b.type==='top_visibility'
    );
    if (topVisibility) {
      return topVisibility;
    }
    const boost_ad=this.product.active_boost.find(
      b => b.type==='boost_ad'
    );
    if (boost_ad) {
      return boost_ad;
    }

    return null;
  },
  urgent_ad() {
    if (!this.product.active_boost||!this.product.active_boost.length) {
      return null;
    }

    // 2️⃣ fallback to boost_ad
    return this.product.active_boost.find(
      b => b.type==='urgent_ad'
    )||null;
  },
};
